/**
 *
 * PortalFooter
 *
 * @version 0.0.7
 * @author Giuseppe
 * @since 25-Oct-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import PortalAnchorButton from '../PortalAnchorButton';
import formattedMessage from './languageModule';
import Logo from 'Assets/images/logo/logo_dark.svg';
import { FormattedMessage } from 'react-intl';
import style from './PortalFooter.scss';

const PortalFooter = (props) => {

	if (window.location.href.toLowerCase().indexOf('startenrollment')!==-1) {
		return '';		
	}

	return <Grid className={style.container}>
		<Grid className={`${style.logo} ${props.logo === '' ? style.placeholder : ''}`}>
			{props.logo !== '' ? <img src={props.logo} alt={`logo ${props.brand}`} /> : ''}
		</Grid>
		<Grid className={style.content}>
			<Typography variant='overline' className={style.paragraph}>
				<FormattedMessage {...formattedMessage.footerText} />
			</Typography>
			<Grid className={style.actions}>
				<PortalAnchorButton
					textTransform='isCapitalize'
					isTranslatedMessage
					contentText={formattedMessage.privacyButton}
					navigationObject={{
						externalNavigation: {
							openInNewTab: true,
							url: 'https://www.nexi.it/it/privacy',
						},
					}}
				/>
				<PortalAnchorButton
					textTransform='isCapitalize'
					isTranslatedMessage
					contentText={formattedMessage.cookieButton}
					navigationObject={{
						externalNavigation: {
							openInNewTab: true,
							url: 'https://www.nexi.it/it/cookie-policy',
						},
					}}
				/>
			</Grid>
		</Grid>
	</Grid>
};

PortalFooter.propTypes = {
	// Add here some propTypes
	// and set a minimal description i.e.
	/** Description of prop "baz". */
	brand: PropTypes.string,
	logo: PropTypes.string,
};

PortalFooter.defaultProps = {
	// Add here some default propTypes values
	brand: '',
	logo: Logo,
};

export default PortalFooter;
